import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import IntegrationOptions from './IntegrationOptions';

export default class IntegrationList extends React.Component
{
    static propTypes = {
        integrations: PropTypes.array.isRequired,
        onDisconnect: PropTypes.func.isRequired
    };

    render()
    {
        return _.map(this.props.integrations, integration => {
            if (integration.disconnected_at) {
                // @todo maybe we need to filter the list before it gets here...
                return null;
            }
            return <div key={integration.id} className="col-span-1 flex items-center bg-white shadow rounded-lg">
                    <div className="flex-shrink-0 flex items-center justify-center w-12 h-12 ml-4 my-2 text-white text-center text-sm leading-5 font-medium bg-cover" style={{backgroundImage: "url('" + integration.picture + "')"}} />
                    <div className="flex-1 px-4 py-2 truncate">
                        <a href="#" className="text-gray-900 text-sm leading-5 font-medium hover:text-gray-600 transition ease-in-out duration-150">
                            {integration.name}
                        </a>
                        <p className="text-sm leading-5 text-gray-500 capitalize">
                            {integration.type}
                        </p>
                    </div>
                    <div className="flex-shrink-0 pr-2">
                        <IntegrationOptions
                            integration={integration}
                            onDisconnect={this.props.onDisconnect}
                        />
                    </div>
                </div>
            }
        );
    }
}
